import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagination } from '@core/models/pagination.model';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { IdentityLogService } from '@core/services/identity-log.service';
import { Store } from '@ngxs/store';
import { FiltersComponent } from '@shared/ui/filters/filters.component';
import { TableNavigatorComponent } from '@shared/ui/table-navigator/table-navigator.component';
import { TableSkeletonLoaderComponent } from '@shared/ui/table-skeleton-loader/table-skeleton-loader.component';
import { IFILTER } from 'app/app.constants';
import { TableActions } from 'app/auth/table-store/table.actions';
import { TableSelectors } from 'app/auth/table-store/table.selectors';
import { BehaviorSubject, Observable, Subscription, take } from 'rxjs';
import { PermissionDirective } from '@shared/directives/permission.directive';
import { TableRefreshComponent } from 'app/ui/table-refresh/table-refresh.component';

@Component({
  selector: 'app-identity-log',
  standalone: true,
  imports: [
    CommonModule,
    FiltersComponent,
    TableSkeletonLoaderComponent,
    TableNavigatorComponent,
    PermissionDirective,
    TableRefreshComponent
  ],
  templateUrl: './identity-log.component.html',
  styleUrl: './identity-log.component.scss',
})
export class IdentityLogComponent implements OnInit, OnDestroy {
  IdentityLogListSubject = new BehaviorSubject<any>(null);
  isFetchingIdentityLogList$!: Observable<boolean>;
  IdentityLogList$ = this.IdentityLogListSubject.asObservable();
  totalCountSubject = new BehaviorSubject<number>(0);
  totalCount$: Observable<number> = this.totalCountSubject.asObservable();
  subs: Subscription[] = [];
  filterStructure: IFILTER[] = [];
  isFilterActive = false;
  hadFilterBefore = false;

  store = inject(Store);
  breadCrumbService = inject(BreadCrumbService);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);


    constructor() {
      this.IdentityLogList$ = this.store.select(TableSelectors.getTableData('identityLog'));
      this.totalCount$ = this.store.select(TableSelectors.getTableTotalCount('identityLog'));;
      this.isFetchingIdentityLogList$ = this.store.select(TableSelectors.getTableLoading('identityLog'));
    }


  ngOnInit() {
    this.breadCrumbService.setPageBreadCrumb(this.activatedRoute);
    this.filterEventListener();
    this.loadIdentityLogList();
    console.log("Identity Log Component Initialized");
    // this.getReferralMetadata();
  }


  filterEventListener() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let query = "";
      if (params['search']) {
        query += `search_text=${params['search']}&`;
      }

      // Handle pagination
      const rawPage = params['page'] ? parseInt(params['page']) : 1;
      const page = rawPage > 1 ? rawPage - 1 : 0;
      const take = 10;
      const skip = page * take;

      if (query) {
        query += `skip=${skip}&take=${take}`;
        this.isFilterActive = true;
        this.hadFilterBefore = true;
        this.store.dispatch(new TableActions.FilterIdentityLogList({ filter: query }));
      } else {
         // only re-fetch if there was a previous filter
         if (this.hadFilterBefore || params['page']) {
          this.hadFilterBefore = false;
          this.store.dispatch(new TableActions.LoadTableData({
            tableKey: 'identityLog',
            params: new Pagination({ skip: skip, size: take }),
          }));
        }
      }
    });
  }
  navigate(currentPage: number) {
    if (this.isFilterActive) {
      this.router.navigate([], {
        queryParams: { page: currentPage },

        queryParamsHandling: 'merge',
      });
    }
  }

    loadIdentityLogList(page = 1) {
      const sub = this.IdentityLogList$.pipe(take(1)).subscribe((referral) => {
        const hasData = Array.isArray(referral) && referral.length > 0;
        // only dispatch if store is empty
        if (!hasData) {
          this.store.dispatch(
            new TableActions.LoadTableData({
              tableKey: 'identityLog',
              params: new Pagination({
                skip: (page - 1) * 10,
                size: 10,
              }),
            })
          );
        }
      });
      this.subs.push(sub);
    }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
